import { render, staticRenderFns } from "./EMensagemAlerta.vue?vue&type=template&id=425e8098&scoped=true"
import script from "./EMensagemAlerta.vue?vue&type=script&lang=js"
export * from "./EMensagemAlerta.vue?vue&type=script&lang=js"
import style0 from "./EMensagemAlerta.vue?vue&type=style&index=0&id=425e8098&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425e8098",
  null
  
)

export default component.exports